import styled from 'styled-components';

export const ListSkeletonStyled = styled.div`
  background-color: ${props => props.theme.uiColors.tableBackgroundColorSolid02};
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  span {
    display: flex;
  }
  
  .listDiagnosisSkeleton {
    &__item {
      align-items: center;
      background-color: ${props => props.theme.uiColors.tableListElementBackgroundColor};
      border-radius: 4px;
      border: 1px solid ${props => props.theme.uiColors.tableListRowBorder};
      box-sizing: border-box;
      display: flex;
      height: 52.77px;
      justify-content: space-between;
      padding: 10px 16px;
      
      & span {
        gap: 20px;
      }
    }
  }
`;
